<template>
  <div class="modal fade" id="pay-status" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div :class="[{'pay-failed-box' : !loading && payFailed },'modal-dialog']" role="document">
      <div class="modal-content loading" v-if="loading">
        <spinner :show="loading" class="spinner-component"></spinner>
      </div>

      <div class="modal-content pay-status" id="pay-success" v-if='paySuccess'>
        <modal-header></modal-header>
        <div class="modal-body text-center">
          <img src="/static/img/dashboard/success_2x.png" alt=" ">
          <h4 class="text-center">{{ $t('paid') }}</h4>
          <p class="payment-info">
            <span>{{ $t('price') }}</span>
            <span class="pull-right">{{ $t(orderInfo.order_detail.currency_symbol) }} {{ orderInfo.order_detail.total_amount }}</span>
          </p>
          <p class="payment-info">
            <span>{{ $t('deviceNum') }}</span>
            <span class="pull-right">{{ orderInfo.max_device_count }} {{ $tc('devices', orderInfo.max_device_count) }}</span>
          </p>
          <p class="payment-info">
            <span>{{ $t('packageTime') }}</span>
            <span class="pull-right">{{ orderInfo.value_of_expire_in }} {{ $tc(orderInfo.unit_of_expire_in, orderInfo.value_of_expire_in) }}</span>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" data-dismiss="modal">{{ $t('sure') }}</button>
        </div>
      </div>

      <div class="modal-content" id="pay-failed" v-else-if="payFailed">
        <modal-header></modal-header>
        <div class="modal-body text-center">
          <img src="/static/img/dashboard/failure_2x.png" alt=" ">
          <h4 class="text-center">{{ $t('payFailed') }}</h4>
          <p v-if="payError">{{ errorNotice }}</p>
          <p v-else>{{ $t('failedNotice') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" data-dismiss="modal">{{ $t('sure') }}</button>
          <p class="contact-us">{{ $t('contactUs') }}</p>
          <p class="email">iplexservice@gmail.com</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import Spinner from '../Spinner.vue'
  import ModalHeader from '../modalHeader/ModalHeader.vue'
  import $ from 'jquery'
  import locales from './lang'
  import {addProduct, setAction} from '../../assets/js/ecommerceAnalytics'
  import cookie from '../../lib/cookie'

  const UaRechargeActions = {
    PAYMENT_SUCCESS: 'Payment success',
    PAYMENT_FAILED: 'Payment failed'
  }

  export default {
    name: 'order-status-notice',
    components: {Spinner, ModalHeader},
    data: function () {
      return {
        loading: false,
        paySuccess: false,
        payFailed: false,
        payError: false,
        isQueryPayStatus: false,
        orderInfo: '',
        notFindOrder: this.$t('notFindOrder'),
        errorNotice: ''
      }
    },
    locales,
    mounted() {
      this.isShowCurrentComponent()
      let vmPayStatus = this
      $('#pay-status').on('hidden.bs.modal', function () {
        vmPayStatus.paySuccess = false
        vmPayStatus.payFailed = false
        vmPayStatus.payError = false
        vmPayStatus.isQueryPayStatus = false
        vmPayStatus.orderInfo = ''
        vmPayStatus.errorNotice = ''
      })
    },
    computed: {
      orderNumber() {
        if (this.$route.query.order_num) {
          return this.$route.query.order_num
        }
      },
      currentPackageId() {
        if (window.localStorage.getItem('currentPackageId')) {
          return window.localStorage.getItem('currentPackageId')
        }
      },
      currentSymbol() {
        return this.$store.state.currentSymbol
      },
      utmCampaign() {
        if (window.sessionStorage.getItem('utmCampaign')) {
          return window.sessionStorage.getItem('utmCampaign')
        }
      },
      currentPaymentMethod() {
        return this.$store.state.currentPaymentMethod
      }
    },
    methods: {
      isShowCurrentComponent() {
        if (this.currentPaymentMethod === 'paypal') {
          return
        }
        if (window.localStorage.getItem('isQueryPayStatus')) {
          this.isQueryPayStatus = window.localStorage.getItem('isQueryPayStatus')
        }
        if (this.isQueryPayStatus && !!this.orderNumber) {
          $('#pay-status').modal('show')
          this.loading = true
          this.getOrderInfo()
        }
      },
      getOrderInfo() {
        this.$http.get('api/topup-order/' + this.orderNumber).then((response) => {
          this.loading = false
          switch (response.body.code) {
            case 0: {
              if (response.body.code === 0) {
                this.orderInfo = response.body.data
                if (this.orderInfo.state === 'paid') {
                  this.trakPackage(this.orderInfo)
                  this.trackRecharge(UaRechargeActions.PAYMENT_SUCCESS)
                  if (this.utmCampaign === 'year-plan-promotion') {
                    this.$ga.event('Promotional recharge success', 'Payment success', 'From promotional email')
                  }
                  this.paySuccess = true
                  if (cookie.getCookie('promotion_source')) {
                    cookie.removeCookie('promotion_source')
                  }
                } else {
                  this.trackRecharge(UaRechargeActions.PAYMENT_FAILED)
                  this.payFailed = true
                }
              }
              break
            }
            case 130: {
              this.payFailed = true
              this.payError = true
              this.errorNotice = this.notFindOrder
              break
            }
          }
          window.localStorage.removeItem('isQueryPayStatus')
          window.localStorage.removeItem('currentPackageId')
          window.localStorage.removeItem('packageId')
          this.$store.commit('setCurrentPayment', '')
        })
      },
      daysToMonths(days) {
        let months = parseInt(days / 30)
        if (months > 12) {
          months = parseInt(days / 365) * 12 + (days % 365) / 30
        }
        let monthsName = months > 1 ? 'Months' : 'Month'
        return months + ' ' + monthsName
      },
      trakPackage(orderInfo) {
        let deviceName = orderInfo.order_detail.device_count > 1 ? 'Devices' : 'Device'
        let packageName = this.daysToMonths(orderInfo.order_detail.available_days) + '/' + orderInfo.order_detail.device_count + ' ' + deviceName
        addProduct({
          'id': this.currentPackageId,
          'name': packageName,
          'price': orderInfo.order_detail.total_amount,
          'deviceCount': orderInfo.order_detail.device_count,
          'quantity': 1
        }, this.currentSymbol)
        setAction('purchase', {
          'id': orderInfo.order_id,
          'revenue': orderInfo.order_detail.total_amount,
          'list': 'PlexVPN',
          'payMethod': orderInfo.order_detail.payment_method_id
        })
      },
      trackRecharge: function (action) {
        // The value (the last argument) must be an integer
        this.$ga.event('Recharge', action, this.orderInfo.order_detail.plan_name, parseInt(this.orderInfo.order_detail.total_amount))
      },
      gtmEvent(eventName) {
        // Event snippet for payment page
        window.dataLayer && window.dataLayer.push({'event': eventName})
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";
  @import "../../assets/scss/reset-modal";
  @import "../../assets/scss/mixins/button";

  .modal {
    .modal-dialog {
      @include modal-dialog($height: 4.5rem);
      @media (max-width: 767px) {
        margin: calc(50vh - 2.25rem) 0 0 -45% !important;
      }
      .loading {
        padding: ((4.5rem - .5rem)/2) 0;
      }
    }
    .pay-failed-box {
      @include modal-dialog($height: 5.3rem);
      @media (max-width: 767px) {
        margin: calc(50vh - 2.65rem) 0 0 -45% !important;
      }
      .loading {
        padding: ((5.3rem - .5rem)/2) 0;
      }
    }
  }

  .modal-content {
    position: relative;
  }

  .loading {
    .spinner-component {
      margin: 0 auto;
    }
  }

  .modal-body {
    padding: 0 .2rem;
    color: #333;
    img {
      width: .5rem;
      margin-bottom: .2rem;
    }
    h4 {
      font-size: .24rem;
      line-height: .3rem;
      margin-bottom: .6rem;
    }
    p {
      font-size: .16rem;
      letter-spacing: .71px;
      line-height: .28rem;
      &.payment-info {
        text-align: left;
        margin-bottom: .1rem;
      }
    }
  }

  .modal-footer {
    text-align: center;
    position: absolute;
    bottom: .4rem;
    width: calc(100% - .4rem);
    button {
      @include modal-button();
    }
    p {
      line-height: .28rem;
      letter-spacing: .53px;
      &.contact-us {
        color: #999999;
        font-size: .12rem;
      }
      &.email {
        font-size: .14rem;
        color: #416CF8;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// PayStatusNotice.vue?6611d641